import { render, staticRenderFns } from "./edit-photos-modal.vue?vue&type=template&id=5f1ad434&scoped=true"
import script from "./edit-photos-modal.vue?vue&type=script&lang=js"
export * from "./edit-photos-modal.vue?vue&type=script&lang=js"
import style0 from "./edit-photos-modal.vue?vue&type=style&index=0&id=5f1ad434&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f1ad434",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/Resourced/Resourced/Frontend-old/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f1ad434')) {
      api.createRecord('5f1ad434', component.options)
    } else {
      api.reload('5f1ad434', component.options)
    }
    module.hot.accept("./edit-photos-modal.vue?vue&type=template&id=5f1ad434&scoped=true", function () {
      api.rerender('5f1ad434', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/pages/components/photo-gallery/edit-photos-modal.vue"
export default component.exports